import {
    ShieldCheck,
    CalendarDays,
    FileKey,
    Building2,
    Hash,
    Clock
} from "lucide-react";


export default function CertificadoCard({ certificado }) {

    if (!certificado) {
        return (
            <div className="p-6 text-center text-muted-foreground">
                No existe certificado registrado
            </div>
        );
    }


    const fechaActual = new Date();
    const fechaFin = new Date(certificado.endDate);

    const vigente = fechaActual <= fechaFin;


    const formatFecha = (fecha) => {
        if (!fecha) return "-";

        return new Date(fecha).toLocaleString("es-DO", {
            dateStyle: "medium",
            timeStyle: "medium"
        });
    };


    return (

        <div className="max-w-3xl mx-auto rounded-xl border bg-card shadow-sm overflow-hidden">

            {/* Header */}
            <div className="bg-primary text-primary-foreground p-6 flex items-center gap-4">

                <div className="rounded-full bg-white/20 p-3">
                    <ShieldCheck size={40} />
                </div>

                <div>
                    <h2 className="text-xl font-bold">
                        Certificado Digital
                    </h2>

                    <p className="text-sm opacity-90">
                        Certificado Calificado VIAFIRMA
                    </p>
                </div>

            </div>


            {/* Estado */}
            <div className="p-4">

                <div className={`rounded-lg p-4 flex items-center justify-center gap-2 font-semibold ${vigente
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                    }`}>

                    <ShieldCheck size={22} />

                    {
                        vigente
                            ? "Certificado Vigente"
                            : "Certificado Expirado"
                    }

                </div>

            </div>



            {/* Datos */}

            <div className="px-6 pb-6 space-y-4">


                <Item
                    icon={<FileKey />}
                    label="Archivo"
                    value={`${certificado.name}.${certificado.extension}`}
                />


                <Item
                    icon={<CalendarDays />}
                    label="Fecha Inicio"
                    value={formatFecha(certificado.startDate)}
                />


                <Item
                    icon={<CalendarDays />}
                    label="Fecha Expiración"
                    value={formatFecha(certificado.endDate)}
                />


                <Item
                    icon={<Hash />}
                    label="Número Serial"
                    value={certificado.serialNumber}
                />


                <Item
                    icon={<Building2 />}
                    label="Emisor"
                    value={certificado.issuerName}
                />


            </div>


            <div className="bg-muted px-6 py-3 text-center text-sm text-muted-foreground">
                Certificado electrónico PKCS#12 (.p12)
            </div>

        </div>

    );
}



function Item({ icon, label, value }) {

    return (

        <div className="flex gap-4 border-b pb-3">

            <div className="text-primary mt-1">
                {icon}
            </div>


            <div className="flex-1">

                <div className="text-sm text-muted-foreground">
                    {label}
                </div>


                <div className="font-medium break-words">
                    {value || "-"}
                </div>

            </div>

        </div>

    );

}


export const getEstadoCertificado = (fecha) => {
    console.log(fecha)
    // Convierte '2027-01-07 14:32:42'
    const fechaVencimiento = new Date(
        fecha.replace(" ", "T")
    );

    const hoy = new Date();

    const diferencia = fechaVencimiento - hoy;

    const dias = Math.ceil(
        diferencia / (1000 * 60 * 60 * 24)
    );


    if (dias <= 3) {
        return {
            texto: `Vence en ${dias} días`,
            color: "bg-red-100 text-red-700 border-red-300"
        };
    }


    if (dias <= 15) {
        return {
            texto: `Vence en ${dias} días`,
            color: "bg-orange-100 text-orange-700 border-orange-300"
        };
    }


    if (dias <= 28) {
        return {
            texto: `Vence en ${dias} días`,
            color: "bg-yellow-100 text-yellow-700 border-yellow-300"
        };
    }


    return {
        texto: `Vigente - ${dias} días restantes`,
        color: "bg-green-100 text-green-700 border-green-300"
    };

};

export function CertificadoInfo({ certificado }) {

    if (!certificado) {
        return (
            <div className="p-6 text-center text-muted-foreground">
                No existe certificado registrado
            </div>
        );
    }






    const estado = getEstadoCertificado(certificado?.endDate || '2001-01-01 00:00:00');




    return (

        <div className="p-4">

            <div className={`rounded-lg p-4 flex items-center justify-center gap-2 font-semibold ${estado.color} `}>

                <ShieldCheck size={22} />

                {estado.texto}

            </div>

        </div>

    );
}